import { defineStore } from 'pinia';
import { axios } from '@boot/axios.js';
import { DEVICE_STATUS } from '@models/devices.js';
import { useSensorsStore } from '@stores/sensors';
/**
 * Return the default state for the devices store.
 */
function getDefaultState() {
    return {};
}
/**
 * Store for managing device-related data.
 */
export const useDevicesStore = defineStore('devices', {
    state: () => getDefaultState(),
    getters: {},
    actions: {
        /**
         * Reset store state.
         */
        resetState() {
            this.$reset();
        },
        /**
         * Get the status of a device given the device id.
         */
        async getDeviceStatusAction(deviceId) {
            const response = await axios.get(`/devices/${deviceId}/status/`);
            // set sensor status
            let deviceStatus = DEVICE_STATUS.offline;
            if (response.data && 'is_online' in response.data) {
                deviceStatus = response.data.is_online
                    ? DEVICE_STATUS.online
                    : DEVICE_STATUS.offline;
            }
            return { deviceStatus };
        },
        /**
         * Load all devices connected to a facility.
         */
        async loadFacilityDevicesAction(facilityId) {
            try {
                const response = await axios.get(`/devices/?facility=${facilityId}`);
                const devices = response.data['results'];
                const sensorsStore = useSensorsStore();
                devices.forEach(device => {
                    if (!device.assets || device.assets.length === 0) {
                        return;
                    }
                    /**
                     * In the facility dashboard the real-time data is hidden if
                     * the asset is not connected to a sensor. This information is
                     * stored in the assets array in the device object.
                     **/
                    sensorsStore.addAssetsWithSensorAction(device.assets);
                });
            }
            catch (error) {
                console.error('Failed to fetch assets data due to: ', error);
                throw error;
            }
        }
    }
});
